import { AxDropdown, AxFormValidation } from "@axess/limestone";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AccountRentalData, AccountRentalDataInitData } from "../Account/AccountRentalData";
import { CustomerLessonProperties, CustomerLessonPropertiesInit } from "../Account/CustomerLessonProperties";

@ModuleName("PersonalData")
export class PersonalData implements AxInit {

    private parentSelector: string;

    private _CountryDropDown: AxDropdown = new AxDropdown();
    private _CommunicationLanguage: AxDropdown = new AxDropdown();
    private _GenderDropDown: AxDropdown = new AxDropdown();
    private _USStateDropDown: AxDropdown = new AxDropdown();
    private subDivisionSearchTimeout: NodeJS.Timeout;
    private _I18nHelper = new I18nHelper;
    private countryList: CountryList[] = [];
    private currentCountry: string | null;
    private currentGender: string | null;
    private currentUSState: string | null;
    private init: IRegistrationData;

    private _accountRentalData: AccountRentalData = new AccountRentalData();
    private _customerLessonProps: CustomerLessonProperties = new CustomerLessonProperties();

    AxInit(init: IRegistrationData): void {
        this.parentSelector = init.parentIdAddress;
        this.currentCountry = init.currentCountry;
        this.currentGender = init.currentGender;
        this.currentUSState = init.currentUSState;
        this.init = init;

        this._accountRentalData.AxInit(new AccountRentalDataInitData(init.parentIdRent));
        this._customerLessonProps.AxInit(new InitCustomerProps(init.lessonPropsParentId, ""));

        this._GenderDropDown.init(`${init.parentIdGender} .accountsettings__gender`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: (x, y) => {
                    $('#Gender').val(y);
                }
            }
        );

        this._CountryDropDown.init(`${init.parentIdAddress} .accountsettings__countryCode`,
            {
                searchBar: true,
                multiSelect: false,
                onSelect: (x, y) => {
                    this.subDivisionSearchTimeout = setTimeout(() => {
                        this.searchSubDivision();
                    }, 200);
                    $('#CountryCode').val(y);
                }
            }
        );

        this._CommunicationLanguage.init('.register__language', {
            searchBar: false,
            multiSelect: false,
            onSelect: (x, y) => {
                $('#Language').val(y);
            },
        });

        this._USStateDropDown.init(`${init.parentIdAddress} .accountsettings__USState`,
            {
                searchBar: true,
                multiSelect: false,
                onSelect: (x, y) => {},
            }
        );

        const observerConfig = {
            attributes: true,
            childList: true,
            subtree: true,
        };

        const countryObserver = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === "childList" || mutation.type === "attributes") {
                    let $selected = $(".ax-dropdown__item__countries").filter(".selected");
                    let isoCode = $selected.attr("data-iso");
                    if (isoCode === $("#CountryCode").val() || isoCode === undefined) return;
                    $("#CountryCode").val(isoCode);

                    this.searchSubDivision();
                }
            }
        });

        AxLoad.LoadModule('AxBirthDateInputTriple', {
            birthdayPattern: init.birthdayPattern,
            parentId: `#account-form`,
            outputTarget: `input[name=DateOfBirthCi]`,
            setBirthDate: $('input[name=DateOfBirthCi]').val() as string
        });

        if ($('#selectedCountry').length > 0) {
            countryObserver.observe(document.getElementById('selectedCountry'), observerConfig);
        }

        $(`.accountsettings__postalCode`).on("keyup", () => {
            if (typeof this.subDivisionSearchTimeout != 'undefined') {
                clearTimeout(this.subDivisionSearchTimeout);
            }

            this.subDivisionSearchTimeout = setTimeout(() => {
                this.searchSubDivision();
            }, 200);
        });

        $('#account-form-submit').on('click', (e) => {
            if (!$('#account-form').valid()) {
                return;
            }

            const languages = $(e.target).data('languages') || [];
            let languageCode;
            if (languages.length > 0) {
                languageCode = languages.filter((l) => l.SprachID == $('#Language').val());
                languageCode = languageCode.length > 0 ? languageCode[0].IsoSprachCode : null;
            }

            this._customerLessonProps.setDescriptionAndGenerateHiddenFieldForLessonProperties('account-form');

            return AxessViewer.saveForm(
                '/ProfileSettings/Update',
                'account-form',
                false,
                () => { },
                languageCode ? { redirect: `/${languageCode}/ProfileSettings` } : {},
                {},
           );
        });

        new AxFormValidation({
            selector: '#account-form',
            rules: this.getValidationRules(),
            messages: this.getValidationMessages(),
        }).init();

        this.searchSubDivision();
        this.getCorrectCountryName();
    }

    getValidationRules(): JQueryValidation.RulesDictionary {
        return {
            PhoneNumber: {
                regex: /^\+?[0-9]+$/,
            },
        };
    }

    getValidationMessages() {
        return {
            ...new AxFormValidation({ selector: '', rules: {} }).getMessages(),
            PhoneNumber: {
                regex: this._I18nHelper.GetTranslation(Translations.I18NextMsgPhoneOnlyNumbers),
            },
        };
    }

    getCorrectCountryName() {
        let $searchables = $("li.ax-dropdown__item__countries");
        let country = $("#CountryCode").val();
        let countryName = '';
        $searchables.each(function () {
            const liContent = $(this).attr('data-iso');
            if (liContent === country) {
                countryName = $(this).text().trim();
            }
        })
        if (countryName === '') return;
        $("#selectedCountry").text(countryName);
        this.checkInputmask();
        $("#height").on("keyup",  () => {
            this.checkInputmask();
        });
    }

    checkInputmask() {
        $('#height').inputmask("999", {
            placeholder: " ",
            greedy: false
        });
    }

    searchSubDivision() {
        let isoCode = $("#CountryCode").val();

        if (isoCode === '') return;

        let countryEntry: CountryList = this.countryList.find(x => x.isoCode === isoCode);

        if (typeof countryEntry != 'undefined') {
            this.printSubDivision(countryEntry.subDivisionList);
            return;
        }

        AxessViewer.loadPartialView('/AccUtil/GetSubDivisionList',
            { iso2Code: isoCode },
            (res: SubDivisionWithCodeList[]) => {
                this.countryList.push({
                    isoCode: isoCode as string,
                    subDivisionList: res
                });
                this.printSubDivision(res);
            }, {});
    }

    printSubDivision(subDivisionList: SubDivisionWithCodeList[]) {
        let postalCode = this.getPostalCode();
        let $dropDownParent: JQuery<HTMLElement> = $(this._CountryDropDown.getElements()[0]);
        let $stateField = $dropDownParent.next('.state-field');

        if (postalCode.length === 0) {
            this.removePostalCodeInfo($stateField);
            return;
        };

        let selectedDivision: SubDivisionWithCodeList = subDivisionList.find((x: SubDivisionWithCodeList) => x.PostalCodes.includes(postalCode));

        if (typeof selectedDivision == 'undefined') {
            this.removePostalCodeInfo($stateField);
            return;
        }

        if ($stateField.length > 0) {
            this.removePostalCodeInfo($stateField);
            $stateField = $dropDownParent.next('.state-field');
        }

        if ($stateField.length === 0) {
            let newInfoDiv = document.createElement('div');
            newInfoDiv.classList.add('ax-form-group');
            newInfoDiv.classList.add('ax-mt-1');
            newInfoDiv.classList.add('state-field');

            let newInfoInput = document.createElement('input');
            newInfoInput.setAttribute('type', 'text');
            newInfoInput.setAttribute('disabled', 'disabled');
            newInfoInput.setAttribute('value', selectedDivision.SubDivision.SubDivisionName);
            newInfoInput.classList.add('ax-form-control');


            let newInfoLabel = document.createElement('label');
            newInfoLabel.classList.add('ax-form-label');
            newInfoLabel.innerText = `${this._I18nHelper.GetTranslation(Translations.State)}`;

            let newInfoDivGroupAssistance = document.createElement('div');
            newInfoDivGroupAssistance.classList.add('ax-form-group-assistence');

            newInfoDiv.appendChild(newInfoInput);
            newInfoDiv.appendChild(newInfoLabel);
            newInfoDiv.appendChild(newInfoDivGroupAssistance);

            $dropDownParent.after(newInfoDiv);
            $stateField = $dropDownParent.next('.state-field');
        }
    }

    removePostalCodeInfo($stateField: JQuery<HTMLElement>): void {
        $stateField.remove();
    }

    getPostalCode(): string {
        return $(`${this.parentSelector} .accountsettings__postalCode`).val() as string;
    }
}

class InitCustomerProps implements CustomerLessonPropertiesInit {
    parentId: string;
    formElementPrefix: string;

    constructor(parentId: string, formElementPrefix: string) {
        this.parentId = parentId;
        this.formElementPrefix = formElementPrefix;
    }
}

interface IRegistrationData {
    parentIdAddress: string;
    parentIdGender: string;
    parentIdRent: string;
    communicationLanguage: string;
    lessonPropsParentId: string;
    currentCountry: string | null;
    currentGender: string | null;
    currentUSState: string | null;
    birthdayPattern: string;
}

class CountryList {
    isoCode: string;
    subDivisionList: SubDivisionWithCodeList[];
}

class SubDivisionWithCodeList {
    SubDivision: CustomerSubDivision;
    PostalCodes: string[];
}

class CustomerSubDivision {
    SubDivisionCode: string;
    SubDivisionName: string;
}